import React, { ChangeEvent, useCallback } from 'react'
import { Box, Input, SearchIcon, Text } from '@woorcs/design-system'
import { useTranslation } from 'react-i18next'
import * as O from 'fp-ts/Option'
import { identity, pipe } from 'fp-ts/function'

import { ListPageFilters } from '@app/components/ListPage'
import { PaginiationLimitSelect } from '@app/components/PaginiationLimitSelect'

import { useCustomerListFiltersContext } from './filters'

export const CustomerListFilters = () => {
  const { t } = useTranslation(['customers'])
  const { filters, setFilter, limit, setLimit } =
    useCustomerListFiltersContext()

  const inputChanged = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setFilter('query', O.some(event.target.value))
    },
    [setFilter]
  )

  return (
    <ListPageFilters>
      <Input
        flexGrow={1}
        width='auto'
        placeholder={t('customers:customersPage.searchInput.placeholder')}
        leftAddon={<SearchIcon size='small' />}
        variant='filled'
        value={pipe(
          filters.query,
          O.fold(() => '', identity)
        )}
        onChange={inputChanged}
      />

      <Box ml={20}>
        {/* <Text fontSize='small' fontWeight='semi-bold' color='grey.400'>
          1-50 of 300
        </Text> */}
        <Box display='none'>
          <PaginiationLimitSelect value={limit} onChange={setLimit} />
        </Box>
      </Box>
    </ListPageFilters>
  )
}
